import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Pagination, Paper } from '@dev/ee-components';

import useMobile from '@/services/hooks/useMobile';
import { getSegmentsStore, SegmentsLoadStart } from '@/store/segments/actions';
import { useRequestParams } from '../../hooks/useRequestParams';

export const PaginationComponent: FC = (): JSX.Element => {
    const dispatch = useDispatch();
    const isMobile = useMobile();
    const segments = useSelector(getSegmentsStore);
    const params = useRequestParams();

    const changePage = (newActivePage: number, newPerPage: number): void => {
        const offset = newActivePage * newPerPage - newPerPage;

        const segmentsLoadParams: { offset?: number; limit?: number; searchName?: string } = {
            offset,
            limit: newPerPage,
            ...(!!params.searchName && { searchName: params.searchName }),
        };
        dispatch(SegmentsLoadStart(segmentsLoadParams));
    };

    const content = (
        <Pagination
            id="segments-pagination"
            activePage={params.page}
            perPage={params.perPage}
            dataLength={segments.currentCollectionTotalCount}
            handlePaginationChange={changePage}
            isRecalculatingActivePage={false}
            disableBorderTop={isMobile}
        />
    );

    if (isMobile) {
        return <Paper margin={{ top: 32 }}>{content}</Paper>;
    }
    return content;
};
